import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as basketActions from '../../actions/components/basket'
import * as stepperActions from '../../actions/components/stepper'
import * as optionGroupsActions from '../../actions/components/optionGroups'
import injectSheet from 'react-jss'
import styles from '../../assets/styles/components/Stepper'
import Stepper from '../../components/Stepper'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    orders: state.orders,
    stash: state.stash,
    waiter: state.waiter,
    stashByOptionGroups: state.stashByOptionGroups,
    isActiveBottomSheetSubmitButton: state.isActiveBottomSheetSubmitButton,
    isSwitchOnEditMode: state.isSwitchOnEditMode,
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    addToOrder,
    setStash,
    resetStash,
  } = bindActionCreators(basketActions, dispatch)

  const {
    switchBottomSheet,
    activeBottomSheetSubmitButton,
  } = bindActionCreators(stepperActions, dispatch)

  const {
    resetStashByOptionGroups,
    resetStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)

  return {
    addToOrder,
    setStash,
    resetStash,
    switchBottomSheet,
    resetStashByOptionGroups,
    resetStashByRadioGroups,
    activeBottomSheetSubmitButton,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(injectSheet(styles)(Stepper))))



// WEBPACK FOOTER //
// ./src/containers/components/Stepper.js